import { Data, Modal as ModalModule, Utils } from 'common';
import React from 'react';
import { isInTrialBillingPeriod } from './planRules';

const { Modal, ModalButtonActionType } = ModalModule;
const { BillingPlans } = Utils;
const { PlanIds } = Data;

interface UpgradeToMultiLocationModalProps {
	modalId: number;
}

const UpgradeToMultiLocationModal = ({
	modalId,
}: UpgradeToMultiLocationModalProps) => {
	const multiLocationPlan = BillingPlans.getPlanByPlanId(
		PlanIds.MultiLocation404
	);
	const price = multiLocationPlan?.Price ?? 49.99;
	const includedSeats = multiLocationPlan?.NumberOfLocations ?? 10;
	const isTrial = isInTrialBillingPeriod();

	const header = isTrial
		? 'Select Multi-Location Plan on your Trial'
		: 'Upgrade to Multi-Location Plan';
	const verb = isTrial ? 'select' : 'switch to';

	return (
		<Modal
			modalId={modalId}
			header={header}
			className="account-subscription upgrade-to-multilocation-modal"
			primaryButton={{
				type: ModalButtonActionType.Confirm,
				text: 'OK',
				dataqa: 'upgrade-to-multilocation-ok',
			}}
		>
			<div className="p-grid">
				<p className="p-col-12">
					The Multi-Location plan starts at ${price.toFixed(2)}/mo with{' '}
					{includedSeats} users included.
				</p>
				<p className="p-col-12">
					To {verb} this plan, please call our support team at 888-434-0055,
					Monday–Friday 8 am – 8 pm Central Time.
				</p>
			</div>
		</Modal>
	);
};

export default UpgradeToMultiLocationModal;
